export const PARTNER_PORTAL_URL = (
  process.env.REACT_APP_PARTNER_PORTAL_URL || 'https://partner.infinicare.ai'
).replace(/\/+$/, '');

export function partnerPortalLogin(): string {
  return `${PARTNER_PORTAL_URL}/login`;
}
